import styled from 'styled-components'
import { COLORS } from 'consts/colors'

export const SpeakerDropdownWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  height: 40px;

  .speaker-dropdown {
    height: 100%;
    input {
      color: ${COLORS.secondaryDark};
      font-size: 14px;
      font-weight: 500;
      line-height: 18px;
    }
  }
`
